@import "/src/styles/mixins.sass"

.primaryActions
    display: flex
    justify-content: center

    button, a
        width: 18rem
        height: 6rem

    svg
        height: 1.5rem

.simulationsList
    display: flex
    flex-direction: column

    .controls
        order: 1
    .labels
        order: 2
    .filters
        order: 3
    .list, .listSkeleton
        order: 4
    .pagination
        order: 5

    @include mappy-bp(tablet desktop)
        .labels
            order: 3
        .filters
            order: 2

.controls
    position: relative
    z-index: 20
    margin-bottom: 1rem
    display: flex
    justify-content: space-between
    align-items: center

    @include mappy-bp(max mobile)
        margin: 0.5rem 0

    @include mappy-bp(max tablet)
        .sort > button
            @include tappable

        .listView
            @include tappable
            color: var(--color-black-primary)
            gap: 0
            padding: 1rem

    @include mappy-bp(tablet)
        .listView
            display: none

    .listView
        position: relative
        margin-right: -1rem

    .sort
        position: relative
        margin-left: -1rem

        & > button
            padding: 1rem
            @include text-small

            &[disabled]
                color: var(--color-black-primary-disabled)

        ul
            @include clickable-styled($outlined: true)
            cursor: auto
            position: absolute
            top: 100%
            max-height: 15rem
            overflow-y: auto
            padding: 0.375rem

        li button
            @include text-small
            width: 100%
            padding: 0.75rem 1rem 0.75rem 0.75rem
            align-items: flex-start

            &:hover
                background-color: var(--color-grey-light)

.labels
    padding: 1rem 2rem
    margin: 0 0.2rem 1em 0.2rem
    display: flex
    gap: 1rem

    @include mappy-bp(max tablet)
        display: none

    @include mappy-bp(tablet desktop)
        span:first-of-type
            flex: 1.5

    span
        @include label-large
        flex: 1

.filters
    position: relative
    z-index: 5
    margin-bottom: 2rem
    display: flex
    gap: 1rem

    & > li
        display: flex
        align-items: flex-end
        justify-content: flex-end
        gap: 1rem

        div, input
            width: 100%

    .closeFiltersButton
        margin-top: 0.75rem
        padding: 0.75rem

    @include mappy-bp(max mobile)
        flex-direction: column

    @include mappy-bp(mobile desktop)
        flex-wrap: wrap
        gap: 1rem

        & > li
            flex-grow: 1
            flex-basis: calc(50% - .5rem)

    @include mappy-bp(tablet desktop)
        margin-bottom: 1rem

    @include mappy-bp(desktop)
        margin: 0 0.2rem 2em 0.2rem
        padding: 0 2rem

        label
            display: none

        & > li
            flex: 1
            padding-right: 2rem
            margin-left: -1rem

        .closeFiltersButton
            margin-top: 0
            width: 100%

.listSkeleton
    position: relative
    z-index: 1
    @include label-large($disabled: true)
    display: flex
    flex-direction: column
    text-align: center
    gap: 4rem

    & > span
        display: flex
        gap: 1rem

    @include mappy-bp(tablet desktop)
        & > span
            span
                flex: 1

            span:first-of-type
                flex: 1.5

    @include mappy-bp(tablet)
        padding: 3rem 2rem
        gap: 4rem
        @include clickable-styled($outlined: true, $block: true, $disabled: true)

    @include mappy-bp(max tablet)
        gap: 2rem

        & > span
            @include clickable-styled($outlined: true, $block: true, $disabled: true)
            padding: 1rem
            display: grid
            grid-template-columns: 3fr 1fr
            grid-template-rows: repeat(3, auto)
            grid-auto-flow: column
            gap: 1rem 20%

.list
    @include mappy-bp(tablet)
        @include clickable-styled($outlined: true, $block: true)
        padding: 1rem
        cursor: auto

        li + li
            box-shadow: inset 0 1px 0 0 var(--color-grey-light), 0 -1px 0 0 var(--color-grey-light)

        li:hover, li:focus-within, li:hover + li, li:focus-within + li
            box-shadow: none

        a
            @include clickable
            @include text
            padding: 2rem 1rem
            display: flex
            gap: 1rem

            div
                flex: 1
                overflow: hidden
                display: flex
                align-items: center
                gap: 0.375rem

            span
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap

            .iconArrow
                justify-content: center

                svg
                    transition: margin-left 0.2s ease

            &:hover, &:focus-visible
                border-radius: 0.75rem
                background-color: var(--color-grey-light)

                .iconArrow svg
                    margin-left: 4rem

    @include mappy-bp(tablet desktop)
        a div:first-of-type
            flex: 1.5

    @include mappy-bp(max tablet)
        display: flex
        flex-direction: column
        gap: 2rem

        a
            @include clickable-styled($outlined: true, $block: true)
            @include text
            padding-left: 1rem

            //sorry for hacks, better than changing html by media query
            display: grid
            grid-template-columns: 1fr auto
            grid-template-rows: repeat(6, auto)

            .name
                padding: 1rem 0 0.375rem
                grid-area: 1 / 1 / 3 / 2

            .date
                grid-area: 3 / 1 / 5 / 2
                @include text--thin

            .status
                grid-area: 5 / 1 / 7 / 2
                padding: 0.375rem 0 1rem
                display: flex
                align-items: center
                gap: 0.375rem

            .type, .iconArrow
                padding: 0 1rem
                display: flex
                justify-content: center
                align-items: center

            .type
                grid-area: 1 / 2 / 4 / 3

            .iconArrow
                background-color: var(--color-black-primary)
                border-radius: 0.75rem
                color: var(--color-white-primary)
                grid-area: 4 / 2 / 7 / 3

        &.compact
            gap: 1rem

            a
                padding: 1rem
                display: flex
                align-items: center
                justify-content: space-between
                gap: 1rem

            .name, .status
                padding: 0

            .date, .type, .iconArrow, .status span
                display: none

    @include mappy-bp(mobile tablet)
        a
            grid-template-columns: 1fr 20%

.pagination
    justify-content: center
    margin-top: 4rem
    display: flex
    gap: 2rem
